export default __webpack_public_path__ + "static/e5aa492d-5737-4b78-9fd1-19ec64c7e72f-ef02f221b0492cdf44d5bdbed64d9d1e.jpg";